









































































































































import { Component, Watch, Model, Vue } from "vue-property-decorator";
import { mapState } from "vuex";
import { GapStatusSummaryReportFilter,GapDateFilter  } from "@/store/modules/types";
import CreatedDateFilter from "@/components/report/filters/CreatedDate.vue";
import LogDateFilter from "@/components/report/filters/LogDate.vue";

@Component({
  computed: mapState("gaps", ["campaigns"]),
  components: {
    CreatedDateFilter,
    LogDateFilter,
  },
})
export default class StatusSummarySearch extends Vue {
  @Model("change") readonly filter!: GapStatusSummaryReportFilter;
  lastShownFilter!: string;
  showCreatedDateFilter = false;
  showLogDateFilter = false;

   @Watch("filter.reportByLog", { deep: true })
  onFilterChanged() {
    this.clearDate();
  }

  showHideFilter(filter: string) {
    if (this.lastShownFilter && this.lastShownFilter !== filter) {
      this.showHideFilter(this.lastShownFilter);
    }
    let show = false;
    switch (filter) {
      case "CREATED_DATE":
        show = !this.showCreatedDateFilter;
        this.showCreatedDateFilter = show;
        break;
      case "LOG_DATE":
        show = !this.showLogDateFilter;
        this.showLogDateFilter = show;
        break;
    }
    this.lastShownFilter = show ? filter : "";
  }

    defaultDateFilter(): GapDateFilter {
    return {
      from: null,
      to: null,
    };
  }

  clearDate() {
    console.log("clearDate");
    console.log(this.filter.reportByLog);
    if(this.filter.reportByLog){
       this.filter.logDate = this.defaultDateFilter();
       this.showCreatedDateFilter = false;
    }else{
      this.filter.createdDate = this.defaultDateFilter();   
      this.showLogDateFilter = false;
    }
    
  }
}
